import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import get from 'lodash/get';
import { Suspense, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import thousands from 'thousands';

import * as Actions from '@/redux/actions';
import { useDispatch, useLocale, useSelector } from 'hooks';
import { localizeFund } from 'lib/utils';
import { useI18n } from 'locales';
import Heading from '../components/Heading';

const selector = (state) => ({
  publicGivingInfo: state.publicGivingInfo,
});

function EntrySuccessContent() {
  const { publicGivingInfo } = useSelector(selector, shallowEqual);
  const dispatch = useDispatch();
  const t = useI18n();
  const locale = useLocale();
  const [searchParams] = useSearchParams();
  const givingId = searchParams.get('id');
  const giving = get(publicGivingInfo, 'data', {});

  useEffect(() => {
    if (givingId) {
      dispatch(Actions.readPublicGiving({ payload: { id: givingId } }));
    }
  }, [dispatch, givingId]);

  useEffect(() => {
    document.title = 'Do Not Require a Receipt – St Andrews Church Kowloon';
  }, []);

  const isLoading = publicGivingInfo.isFetching;

  if (isLoading && !publicGivingInfo.dataFetched) {
    return (
      <Stack sx={{
        backgroundColor: 'background.default',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}>
        <CircularProgress />
      </Stack>
    );
  }
  return (
    <Stack sx={{
      backgroundColor: 'background.default',
      alignItems: 'center',
      pb: 8,
    }}>
      <Heading />

      <Grid gap={2} sx={{ flexDirection: 'column', display: 'flex', alignItems: 'center', px: 2, py: 3 }}>
        <Typography color='green.500' sx={{ fontSize: 120 }}>
          <FontAwesomeIcon icon={faCircleCheck} />
        </Typography>

        <Typography variant='h4' color='secondary' sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          {t('THANK YOU FOR YOUR SUPPORT!')}
        </Typography>

        <Stack gap={0.5}>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('You have successfully made a {{term}} giving to', { term: t(get(giving, 'type', '')) })} {localizeFund(get(giving, 'fund', {}), locale) || '[Fund Name]'}.
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('Amount: HKD ')}{thousands((giving.amount || 0).toFixed(2))}
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('Ref ID: ')}<code>{giving.refId}</code>
          </Typography>
          <Typography variant='body1' color='info.700' sx={{ textAlign: 'center' }}>
            {t('A confirmation email has been sent to your email address.')}
          </Typography>
        </Stack >
      </Grid >

    </Stack >
  );
}

function EntrySuccessPage() {
  return (
    <Suspense fallback={
      <Stack sx={{
        backgroundColor: 'background.default',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}>
        <CircularProgress />
      </Stack>
    }>
      <EntrySuccessContent />
    </Suspense>
  );
}

export default EntrySuccessPage;
